import { makeStyles } from '@mui/styles';
import { defaultIcon } from '../../default';

const arrowRightDefault: any = {
  '&:after, &:before': {
    width: '40%',
    top: '-.095em',
    left: 'calc(100% - .3625em)',
    transform: 'rotate(40deg)',
  },
  '&:after': {
    top: 'auto',
    bottom: '-.095em',
    transform: 'rotate(-40deg)',
  },
};

const arrowLeftDefault: any = {
  '&:after, &:before': {
    width: '40%',
    top: '-.095em',
    left: '-.0325em',
    transform: 'rotate(-40deg)',
  },
  '&:after': {
    top: 'auto',
    bottom: '-.095em',
    transform: 'rotate(40deg)',
  },
};

const useStyles = makeStyles({
  arrowUp: {
    ...defaultIcon,
    ...arrowRightDefault,
    transform: 'translate(-50%, -50%) rotate(-90deg)',
  },
  arrowDown: {
    ...defaultIcon,
    ...arrowLeftDefault,
    transform: 'translate(-50%, -50%) rotate(-90deg)',
  },
  arrowLeft: {
    ...defaultIcon,
    ...arrowLeftDefault,
  },
  arrowRight: {
    ...defaultIcon,
    ...arrowRightDefault,
  },
});

export default useStyles;
